import actions from './actions'

const initialState = {
    email: '',
    uuid: '',
    first_name: '',
    last_name: '',
    workspaces: [],
    loading: false,
    authorized: false,
    activeWorkspace: null
};

export default function userReducer(state = initialState, action: { type: string; payload: any; }) {
  switch (action.type) {
    case actions.SET_STATE:
      return { ...state, ...action.payload }
    default:
      return state
  }
}
